<template>
  <div>
    <!-- <h2 v-show="!isLoading" class="intro-y text-lg font-medium mt-10">
      Cases presided by {{ judge.name }} - {{ cases.length }} case(s)
    </h2> -->
    <div v-show="!isLoading" class="intro-y flex items-center h-10 mt-10">
      <h2 class="text-lg font-medium">
        Cases Being Presided by {{ judge.name }} - {{ cases.length }} case(s)
      </h2>
      <a
        href="#"
        class="text-lg ml-auto flex text-theme-1 dark:text-theme-10 items-center"
        @click="
          () => {
            this.$router.back();
          }
        "
      >
        <ArrowLeftCircleIcon class="w-4 h-4 mr-3" /> Back
      </a>
    </div>
    <div v-if="isLoading" class="text-center pt-16">
      <p class="text-3xl">Loading...</p>
    </div>
    <div v-if="!isLoading" class="grid grid-cols-12 gap-6 mt-5">
      <!-- BEGIN: Judges' Cases -->
      <div
        v-for="(caseFile, key) in cases"
        :key="key"
        class="intro-y col-span-12 sm:col-span-6 xl:col-span-4"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center py-5 px-1">
            <div
              class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
            >
              <a
                :href="`${host_url}/cases/${caseFile.slug}`"
                class="font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ caseFile.name }}
              </a>
              <div class="text-gray-600 text-sm">
                {{ caseFile.case_type.name }}
              </div>
              <div class="text-gray-600 text-xs">
                {{ caseFile.case_stage }}
              </div>
            </div>
            <div class="text-theme-9">
              <div class="w-24 py-1 px-2 text-center">
                {{
                  caseFile.duration_in_days > 0
                    ? caseFile.duration_in_days
                    : caseFile.duration_in_years > 0
                    ? caseFile.duration_in_years
                    : caseFile.duration_in_days
                }}
                {{
                  caseFile.duration_in_days > 0
                    ? "day(s)"
                    : caseFile.duration_in_years > 0
                    ? "year(s)"
                    : "day(s)"
                }}
              </div>
              <div class="text-center">
                {{ caseFile.case_status }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BEGIN: Users Layout -->
      <!-- BEGIN: Pagination -->
      <!-- <div class="intro-y col-span-12 text-center">
        <button
          class="button text-white bg-theme-1 shadow-md justify-self-center"
        >
          Load More
        </button>
      </div> -->
      <!-- END: Pagination -->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "JudgeCases",
  data() {
    return {
      cases: [],
      judge: {},
      isLoading: true,
      host_url: process.env.VUE_APP_CCD_CLIENT_URL
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getJudgeCases();
      }
    }
  },
  mounted() {
    this.getJudgeCases();
  },
  methods: {
    getJudgeCases() {
      axios
        .get(`${window.host}/api/judge-cases/${this.$route.params.id}`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.judge = response.data;
            this.cases = response.data.cases;
          }
          this.isLoading = false;
        });
    }
  }
};
</script>
